import { useLocation } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';

interface Site {
    site: {
        siteMetadata: {
            siteUrl: string;
        };
    };
}

export const useCurrentURL = () => {
    const { site }: Site = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        siteUrl
                    }
                }
            }
        `,
    );
    const { pathname } = useLocation();

    return site.siteMetadata.siteUrl + pathname;
};
